// extracted by mini-css-extract-plugin
export default {"QualityDetails_chartTitle":"QualityDetails_QualityDetails_chartTitle__5nVYS","QualityDetails_chartTotal":"QualityDetails_QualityDetails_chartTotal__TihF9"};